import { render, staticRenderFns } from "./HomeChallenges.vue?vue&type=template&id=35b8684c&scoped=true"
import script from "./HomeChallenges.vue?vue&type=script&lang=ts"
export * from "./HomeChallenges.vue?vue&type=script&lang=ts"
import style0 from "./HomeChallenges.vue?vue&type=style&index=0&id=35b8684c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b8684c",
  null
  
)

export default component.exports